// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import store from './store';
import axios from 'axios';
// import 'lib-flexible/flexible';
import './utils/flexible';
import ElementUI from 'element-ui';
import VueCanvasPoster from 'vue-canvas-poster';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// import VConsole from 'vconsole';
// let vconsole = new VConsole();

import DOMPurify from 'dompurify';

Vue.filter('sanitize', dirty => {
  return DOMPurify.sanitize(dirty);
});

Vue.prototype.$axios = axios;
Vue.use(ElementUI);
Vue.use(VueCanvasPoster);

Vue.config.productionTip = false;
// 完整加载
import VueLuckyCanvas from '@lucky-canvas/vue';
Vue.use(VueLuckyCanvas);
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import style
import 'swiper/css/swiper.css';

Vue.use(VueAwesomeSwiper /* { default options with global component } */);
Vue.config.productionTip = false;

import { debounce } from 'lodash';
Vue.prototype.$debounce = debounce;

Vue.directive('debounce-click', {
  bind(el, binding) {
    const { value, arg } = binding;
    const callback = typeof value === 'function' ? value : value.handler;
    const delay = arg ? parseInt(arg) : 300;

    const debouncedCallback = Vue.prototype.$debounce(callback, delay);

    el.addEventListener('click', debouncedCallback);
  },
  unbind(el, binding) {
    const { value } = binding;
    const callback = typeof value === 'function' ? value : value.handler;

    el.removeEventListener('click', callback);
  }
});

//弹出框禁止滑动
Vue.prototype.stopScroll = function () {
  var mo = function (e) {
    e.preventDefault();
  };
  document.body.style.overflow = 'hidden';
  document.addEventListener('touchmove', mo, false); // 禁止页面滑动
};

//弹出框可以滑动
Vue.prototype.canScroll = function () {
  var mo = function (e) {
    e.preventDefault();
  };
  document.body.style.overflow = ''; // 出现滚动条
  document.removeEventListener('touchmove', mo, false);
};
Vue.config.ignoredElements = [
  'wx-open-launch-app'
  // 如果你还用了其他微信开放标签，也一并添加进来
];
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js